import React, { useState } from 'react';
import { ShoppingCartIcon, UserIcon, MenuIcon, XIcon, SparklesIcon } from 'lucide-react';
export function BabyHeader() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  return <header className="w-full" data-id="element-126">
      {/* Promotional Banner - Redesigned */}
      <div className="bg-baby-gradient-pink-blue text-white relative overflow-hidden" data-id="element-127">
        {/* Decorative elements */}
        <div className="absolute top-0 left-0 w-32 h-32 bg-white/10 rounded-full blur-2xl" data-id="element-128"></div>
        <div className="absolute bottom-0 right-0 w-40 h-40 bg-white/10 rounded-full blur-2xl" data-id="element-129"></div>

        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 py-4 sm:py-5 md:py-6" data-id="element-130">
          <div className="flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-3 text-center" data-id="element-131">
            {/* Icon */}
            <div className="flex items-center gap-2" data-id="element-132">
              <SparklesIcon className="w-5 h-5 sm:w-6 sm:h-6 animate-soft-pulse" data-id="element-133" />
              <span className="text-sm sm:text-base md:text-lg font-extrabold tracking-wide" data-id="element-134">
                LANZAMIENTO ESPECIAL
              </span>
              <SparklesIcon className="w-5 h-5 sm:w-6 sm:h-6 animate-soft-pulse" data-id="element-135" />
            </div>

            {/* Separator */}
            <span className="hidden sm:inline text-white/60 text-lg" data-id="element-136">•</span>

            {/* Main message */}
            <div className="text-base sm:text-lg md:text-xl font-bold leading-snug" data-id="element-137">
              <span className="inline-block" data-id="element-138">
                30 Recetas Seguras para Tu Bebé
              </span>
              <span className="hidden sm:inline mx-2" data-id="element-139">+</span>
              <span className="block sm:inline mt-1 sm:mt-0" data-id="element-140">
                Guías Completas
              </span>
            </div>
          </div>

          {/* Subtext */}
          <div className="text-center mt-2 text-xs sm:text-sm text-white/90 font-medium" data-id="element-141">
            🎁 Descarga instantánea • Garantía 30 días
          </div>
        </div>
      </div>

      {/* Trust Banner */}
      <div className="bg-baby-cream text-center py-2.5 sm:py-3 px-3 sm:px-4 text-xs sm:text-sm text-gray-700 font-medium border-b border-baby-pink-light/30" data-id="element-142">
        <span className="inline-flex items-center gap-2" data-id="element-143">
          <span data-id="element-144">⚡</span>
          <span data-id="element-145">Acceso digital instantáneo</span>
          <span className="hidden sm:inline text-baby-pink" data-id="element-146">•</span>
          <span className="hidden sm:inline" data-id="element-147">
            Basado en recomendaciones pediátricas
          </span>
        </span>
      </div>

      {/* Main Navigation */}
      <nav className="border-b border-baby-pink-light/30 sticky top-0 bg-white/95 backdrop-blur-baby z-50 shadow-baby-soft" data-id="element-148">
        <div className="max-w-7xl mx-auto px-3 sm:px-4 py-3 sm:py-3.5 md:py-4" data-id="element-149">
          

          {/* Mobile Menu */}
          {mobileMenuOpen && <div className="md:hidden mt-4 pb-4 border-t border-baby-pink-light/30 pt-4 animate-fade-in-up" data-id="element-150">
              <div className="flex flex-col space-y-3" data-id="element-151">
                <a href="#recetas" onClick={() => setMobileMenuOpen(false)} className="text-gray-700 hover:text-baby-pink transition text-base font-medium py-2 px-3 rounded-baby hover:bg-baby-pink-light/30" data-id="element-152">
                  Ver Recetas
                </a>
                <a href="#testimonios" onClick={() => setMobileMenuOpen(false)} className="text-gray-700 hover:text-baby-blue transition text-base font-medium py-2 px-3 rounded-baby hover:bg-baby-blue-light/30" data-id="element-153">
                  Testimonios
                </a>
              </div>
            </div>}
        </div>
      </nav>
    </header>;
}